import { render } from "./ProcessUpdate.vue?vue&type=template&id=1026f416&scoped=true"
import script from "./ProcessUpdate.vue?vue&type=script&lang=ts"
export * from "./ProcessUpdate.vue?vue&type=script&lang=ts"

import "./ProcessUpdate.vue?vue&type=style&index=0&id=1026f416&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1026f416"

export default script